<template>
  <div class="fccMensagens">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <fcc-table
        class="mt-4"
        empty-text="Não existem registros"
        por-page="25"
        :optionsButton="optionsButton"
        :title-page="titlePage"
        :title-p-d-f="titlePage"
        :items="listagemMensagemPage"
        :fields="fieldsMensagensTabela"
        :actions="actionsMensagensTabela"
        hover
        search
        pagination
        fieldVisibility
        pdf
        csv
        xls
      >
        <template #mendeststatus="{ row, value }">
          <button
            style="border: none; background-color: transparent"
            :style="value === 1 ? 'opacity: 0.5' : 'opacity: 1'"
            v-b-tooltip.hover
            :title="value === 1 ? 'Marcar como não Lida' : 'Marcar como Lida'"
            @click="marcarLidoModal(row, value === 1 ? 0 : 1)"
          >
            <font-awesome-icon :icon="value === 1 ? 'envelope-open' : 'envelope'" size="lg" />
          </button>
        </template>
      </fcc-table>
    </div>
    <fccModal
      centered
      :idModal="titleModal"
      addClass="visualizarNotificaao"
      :titleModal="mensagem.mentitulo"
      escondeFooter
      escondeTopo
      travaEsc
      travaBack
      size="xl"
      v-if="mensagem"
    >
      <div class="visualizarNotificaao">
        <div class="notificacaoHeader">
          <div class="row">
            <div class="col-sm-8">
              <h5>{{ mensagem.mentitulo }}</h5>
            </div>
            <div class="col-sm-4 text-right notificacoesButtons">
              <button
                v-b-tooltip.hover
                title="Marcar como Não Lido"
                @click="marcarLidoModal(mensagem, 0)"
              >
                <font-awesome-icon icon="envelope" size="lg" />
              </button>
              <button v-b-tooltip.hover title="Fechar" @click="fecharMensagemModal()">
                <font-awesome-icon icon="times" size="lg" />
              </button>
            </div>
          </div>
          <hr />
          <div class="notificacaoContent">
            <div class="row">
              <div class="col-sm-12">
                <p v-html="mensagem.mencorpo"></p>
              </div>
            </div>
            <hr />
            <div class="row footer">
              <div class="col-sm-6 remetente"></div>
              <div class="col-sm-6 text-right datas" v-if="mensagem.mendatacriacao">
                {{ mensagem.mendatacriacao | moment('DD/MM/YYYY h:m:s') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </fccModal>
    <fccModal
      centered
      :idModal="titleModalAdd"
      addClass="visualizarNotificaao"
      titleModal="Adicionar Notificação"
      escondeFooter
      travaEsc
      travaBack
      size="xl"
    >
      <form @submit.prevent="adicionandoMensagem">
        <div class="row">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" required v-model="criarMensagem.mentitulo"
              >Título Notificação</fccInput
            >
            <input type="hidden" v-model="criarMensagem.menfreid" />
            <input type="hidden" v-model="criarMensagem.appid" />
            <input type="hidden" v-model="criarMensagem.appid" />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <v-select
              :options="listagemTipoMensagem"
              v-model="criarMensagem.mentipid"
              placeholder="Selecione"
              label="mentipdescricao"
              :reduce="(mentipdescricao) => mentipdescricao.mentipid"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!criarMensagem.mentipid"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <v-select
              multiple
              :options="usuariosListados"
              v-model="valueDestinatario"
              placeholder="Escolha os Usuários"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!valueDestinatario"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <v-select
              multiple
              v-model="valueGrupo"
              label="pernome"
              :options="usuariosGrupos"
              placeholder="Escolha os Grupos"
            />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <vue-editor v-model="criarMensagem.mencorpo" required />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <toggle-button v-model="criarMensagem.menbloqueiotela" value="false" /> Bloqueio de Tela
          </div>
          <div class="col-sm-6">
            <toggle-button v-model="criarMensagem.menimportante" value="false" /> Mensagem
            Importante
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import './assets/sass/fccMensagens.scss'
import store from '../../store'
export default {
  data() {
    return {
      titlePage: 'Mensagens',
      listagemMensagem: [],
      baseUrlNotificacao: '',
      baseUrlSeguranca: '',
      listagemMensagemPage: [],
      listagemTipoMensagem: [],
      mensagem: [],
      filtro: '',
      valueDestinatario: [],
      valueGrupo: [],
      selectPlanet: [],
      mensagemDestinatariosGrupo: [],
      semStatus: false,
      tipoMensagem: 'NO',
      titleModal: '',
      selectOk: false,
      titleModalAdd: '',
      usuariosGrupos: [],
      usuariosListados: [],
      tipoEnvio: '',
      totalPageRow: 0,
      criarMensagem: {},
      currentPage: 1,
      controleSelect: 'false',
      totalPage: 0,
      finalPage: 0,
      perPage: 100,
      itemPorPage: 100,

      fieldsMensagensTabela: [
        {
          key: 'mendeststatus',
          label: 'Status',
          type: 'slot',
          sortable: false,
          active: true
        },
        {
          key: 'mentitulo',
          label: 'Título',
          sortable: true,
          active: true
        },
        {
          key: 'mentipdescricao',
          label: 'Descrição',
          sortable: false,
          active: true
        },
        {
          key: 'mendatacriacao',
          label: 'Data',
          sortable: false,
          active: true
        },
        { key: 'actions', label: '', active: true }
      ],
      actionsMensagensTabela: [
        {
          button: true,
          funcaoButton: this.verMensagemModal,
          icon: 'eye',
          tooltip: 'Emular',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      optionsButton: [
        {
          funcaoButton: 'addField',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
  },
  methods: {
    gerarCampos: function () {
      this.criarMensagem = {
        menfreid: 4,
        mencorpo: '',
        mendatacriacao: this.capturaDataAtualSGP(),
        mendataexclusao: '',
        menentid: '',
        appid: process.env.VUE_APP_API_ID
      }
      this.valueDestinatario = []
    },
    listandoMensagensTipo: function () {
      axios
        .get(
          this.baseUrlNotificacao + 'MensagensTipo/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemTipoMensagem = response.data
        })
        .catch(this.setErrorSystem)
    },
    pushUsuarios: function (users) {
      this.mensagemDestinatariosGrupo.findIndex((x) => x.mendestusu === users) === -1
        ? this.mensagemDestinatariosGrupo.push({
            mendestusu: users,
            mendesid: 0,
            menid: 0,
            mendeststatus: 0
          })
        : (users = '')
    },
    verificaUser: function () {
      if (this.valueDestinatario.length > 0) {
        for (var idGrupo of Object.values(this.valueDestinatario)) {
          this.pushUsuarios(idGrupo)
        }
      }
    },
    verificaGrupo: async function () {
      if (this.valueGrupo.length > 0) {
        for (var Grupo of Object.values(this.valueGrupo)) {
          await axios
            .get(
              this.baseUrlSeguranca + 'Perfil/listarusuariogrupoporpai/' + Grupo.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then((response) => {
              var idUserGrupo = response.data
              if (idUserGrupo.length > 0) {
                for (var idUser of Object.values(idUserGrupo)) {
                  if (idUser.usuid !== null) {
                    this.pushUsuarios(idUser.usuid)
                  }
                }
              }
              return idUserGrupo
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      }
    },
    adicionandoMensagem: async function () {
      this.arrayVerifica = []
      this.mensagemDestinatariosGrupo = []
      await this.verificaGrupo()
      this.verificaUser()
      if (this.criarMensagem.menCorpo !== '') {
        this.criarMensagem = {
          menid: 0,
          mentipid: this.criarMensagem.mentipid,
          menfreid: 4,
          mentitulo: this.criarMensagem.mentitulo,
          mencodigo: this.criarMensagem.mentitulo,
          menstatus: 0,
          menentid: 1,
          mencorpo: this.criarMensagem.mencorpo,
          mendatacriacao: this.capturaDataAtualSGP(),
          menusuenvio: this.dadosUserSession.usuID,
          appid: this.criarMensagem.appid,
          mendataalteracao: this.capturaDataAtualSGP(),
          mendataexclusao: this.capturaDataAtualSGP(),
          mendataexpiracao: this.capturaDataAtualSGP(),
          mencomlembrete: true,
          menimportante: this.criarMensagem.menimportante,
          menbloqueiotela: this.criarMensagem.menbloqueiotela,
          mendataproxlembrete: this.capturaDataAtualSGP(),
          menidexterno: 0,
          mensagemdestinatarios: this.mensagemDestinatariosGrupo
        }
        axios
          .post(
            this.baseUrlNotificacao + 'Mensagem/Adicionar',
            this.criarMensagem,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.$root.$emit('bv::hide::modal', this.titleModalAdd)
            this.callToast('Enviado com Sucesso', 'success')
            this.listandoTipoMensagens()
          })
          .catch((error) => {
            this.$root.$emit('bv::hide::modal', this.titleModalAdd)
            this.setErrorSystem(error)
          })
      } else {
        this.callAlert('Erro', 'Insira uma mensagem', 'error', 'error')
      }
    },
    listarUsuarios: function () {
      axios
        .get(
          this.baseUrlSeguranca + 'Cadastro/listartodoslogin',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          var usuariosTotal = response.data
          for (var user of Object.values(usuariosTotal)) {
            this.usuariosListados.push(user.usuid)
          }
        })
        .catch(this.setErrorSystem)
    },
    listarGrupos: function () {
      axios
        .get(this.baseUrlSeguranca + 'Perfil/listarperfil', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          var gruposTotal = response.data
          for (var grupo of Object.values(gruposTotal)) {
            this.usuariosGrupos.push({
              id: grupo.perid,
              pernome: grupo.pernome
            })
          }
        })
        .catch(this.setErrorSystem)
    },
    marcarLidoModal: function (listaNotificacao, status) {
      axios
        .put(
          this.baseUrlNotificacao +
            'MensagemDestinatario/AlterarStatusNotificacao/' +
            listaNotificacao.mendesid +
            '/' +
            status +
            '/' +
            true,
          {},
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoTipoMensagens()
        })
        .catch(this.setErrorSystem)
    },
    listandoTipoMensagens: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlNotificacao +
            'MensagemDestinatario/ListarMensagemDestinatario/' +
            this.dadosUserSession.usuID +
            '/0/' +
            this.tipoMensagem +
            '/' +
            this.semStatus,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemMensagemPage = response.data.table.reverse()
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    fecharMensagemModal: function () {
      this.mensagem = []
      this.$root.$emit('bv::hide::modal', this.titleModal)
    },
    verMensagemModal: function (_, item) {
      this.mensagem = item
      this.marcarLidoModal(item, 1)
      this.$root.$emit('bv::show::modal', this.titleModal)
    },
    addField: function (tipo = 'user') {
      this.listandoMensagensTipo()
      this.gerarCampos()
      this.tipoEnvio = tipo
      this.$root.$emit('bv::show::modal', this.titleModalAdd)
    }
  },
  mounted: function () {
    this.baseUrlNotificacao = this.$fccStore.state.baseUrlNotificacao
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.titleModalAdd = 'mensagemsModalAdd' + this.geraNome()
    this.titleModal = 'mensagemsModalEditar' + this.geraNome()
    this.listandoTipoMensagens()
    this.listarGrupos()
    this.listarUsuarios()
  }
}
</script>
